import { service } from '@ember/service'
import Route from '@ember/routing/route'
import type Store from '@ember-data/store'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import { assert } from '@ember/debug'
import type Student from 'teacher-ui-client/models/student'
import type FeaturesService from 'teacher-ui-client/services/features'
import type DateFilterService from 'teacher-ui-client/services/date-filter'
import type Transition from '@ember/routing/transition'

export default class CertificatesRoute extends Route<unknown> {
  @service store!: Store
  @service features!: FeaturesService
  @service dateFilter!: DateFilterService

  queryParams = {
    sortCol: {
      replace: true,
      refreshModel: false,
    },
    sortDir: {
      replace: true,
      refreshModel: false,
    },
    sortCompare: {
      replace: true,
      refreshModel: false,
    },
    currentPage: {
      replace: true,
      refreshModel: false,
    },
    textFilter: {
      replace: true,
      refreshModel: false,
    },
    selectedIds: {
      replace: true,
      refreshModel: false,
    },
    product: {
      replace: true,
      refreshModel: false,
    },
    recordsPerPage: {
      replace: true,
    },
    dateRange: {
      replace: true,
      refreshModel: true,
    },
    typeFilter: {
      replace: true,
      refreshModel: false,
    },
  }

  beforeModel(transition: Transition) {
    // transition queryParams dateRange is undefined if no value set yet (it doesnt fallback to the controller value).
    const dateRange = transition.to?.queryParams.dateRange
    if (typeof dateRange === 'string' && dateRange !== '') {
      this.dateFilter.dateRange = dateRange
    } else {
      this.dateFilter.dateRange = this.dateFilter.toDateRange(this.dateFilter.thisAcademicPeriod)
    }
  }

  async model() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute

    const writingCertificatesEnabled = this.features.isEnabled('tui_writing_certificates')

    const allowedTypes = [
      SubscriptionType.Reading,
      SubscriptionType.Maths,
      ...(writingCertificatesEnabled ? [SubscriptionType.Writing] : []),
    ]

    assert(
      'only reading and maths subscription types support manage certificates in TUI (writing requires feature flag)',
      allowedTypes.includes(subscriptionType),
    )

    // get students for subtype, and their teachers. To fill into the certificates table data
    const students = await this.store.query<Student>(
      'student',
      {
        filter: { 'subscription-type': subscriptionType },
        // @ts-expect-error - include types not correct
        include: 'school-classes,school-classes.teachers',
      },
      { adapterOptions: { usePost: true } },
    )

    return {
      subscriptionType,
      students,
    }
  }
}
